import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { CloseApproachConsentsPage, CloseApproachConsentsPageProps } from "./CloseApproachConsentsPage";

export const EMPTY_PAGE_CONTENT: CloseApproachConsentsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/close-approach-consents";

export const CloseApproachConsentsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<CloseApproachConsentsPageProps>("close_approach_consent_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <CloseApproachConsentsPage {...routeProps} {...content} />;
};
